import { Navigate, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

const checkToken = () => localStorage.getItem("token") !== null;
const allowedWithToken = [ // have to add these routes as during forgot passwrd we have to save token in localstorage as need tht in change password page but if token is there automatically redirected to protected route, to change that behaviour using this
  "/auditor/auth/forgot_password",
  "/auditor/auth/change_password",
   "/auditor/auth/signup",
];


const PublicRoute = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tokenFromParams = params.get("token");
  const tour = params.get("tour");
  const allowParam = params.get("allow"); // from changepassword page getting this param but it won't be shown in url as in Login page onmount deleting it
  
  const decryptToken = (ciphertext) => {
    const secretKey = "e9w9r3q1w7d4f7t1g6c0s7v6c1x7z3b8m1y9e6a4q7e5t0r6n0l1p3u8a4z0h4!@#";
    const decodedCiphertext = decodeURIComponent(ciphertext);
    const bytes = CryptoJS.AES.decrypt(decodedCiphertext, secretKey);
    const originalToken = bytes.toString(CryptoJS.enc.Utf8);
    return originalToken;
};
  if (tokenFromParams) {
    const decryptedToken = decryptToken(tokenFromParams);
    localStorage.setItem("token", decryptedToken);
}

if(tour){
  localStorage.setItem("is_tour_complete",tour);
}
  // return checkToken() ? <Navigate to="/auditor/audit" replace /> : children;
  if (
  checkToken() &&
  !allowedWithToken.some(path => location.pathname.startsWith(path)) && // so that with token also it doesn't redirect to private route
  !(location.pathname === "/auditor/auth/login" && allowParam === "1") // when coming from change password page to login page
) {
  return <Navigate to="/auditor/audit" replace />;
}
return children;
};

export default PublicRoute;
